<div class="submodel-element-list">
  <div class="sel-header d-flex justify-content-between align-items-center">
    <ix-typography>{{ element.idShort | translateOrFallback:(element.idShort ?? '') }}</ix-typography>
    <ix-button
      (click)="addItem()"
      icon="add-circle"
      variant="subtle-tertiary"
      onkeydown=""
    >
      {{ 'dpp.generic_submodel_editor.add_value' | translate }}
    </ix-button>
  </div>

  <ix-layout-grid class="pe-0 ps-0">
    @if (controls.length === 0) {
      <ix-row class="d-flex justify-content-center">
        <ix-col class="text-center" size="12">
          <ix-empty-state
            (actionClick)="addItem()"
            action="{{ 'dpp.generic_submodel_editor.add_value' | translate }}"
            header="{{
              'battery_pass.edit.empty_list.attribute_header' | translate
            }}"
            layout="compact"
            subHeader="{{
              'battery_pass.edit.empty_list.attribute_subheader' | translate
            }}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    }

    @for (control of controls; track $index; let i = $index) {
      <ix-row class="expandable-row">
        <ix-icon-button
          icon="trashcan"
          variant="subtle-primary"
          (click)="removeItem(i)"
          onkeydown=""
        ></ix-icon-button>
        <ix-col class="py-0 ps-3 pe-0 border-left">
          @if (isFormGroup(control)) {
            <!-- Collection item: render each field -->
            <div class="d-flex flex-column gap-2">
              @for (field of getCollectionFields(i); track field.idShort) {
                @switch (field.modelType) {
                  @case (SubmodelElementTypes.Property) {
                    <app-property
                      [element]="field"
                      [control]="
                        getControlForField(asFormGroup(control), field.idShort!)
                      "
                    />
                  }
                  @case (SubmodelElementTypes.File) {
                    <app-file
                      [element]="field"
                      [control]="
                        getControlForField(asFormGroup(control), field.idShort!)
                      "
                    />
                  }
                  @case (SubmodelElementTypes.MultiLanguageProperty) {
                    <app-multi-language-property
                      [element]="field"
                      [formGroup]="
                        getFormGroupForField(
                          asFormGroup(control),
                          field.idShort!
                        )
                      "
                    />
                  }
                  @default {
                    <ix-key-value
                      [label]="field.idShort | translateOrFallback:(field.idShort ?? '')"
                      [value]="field.modelType"
                    ></ix-key-value>
                  }
                }
              }
            </div>
          } @else {
            <!-- Simple value item -->
            <ix-input
              [formControl]="$any(control)"
              class="w-100"
              [id]="'sel_' + element.idShort + '_' + i"
            />
          }
        </ix-col>
      </ix-row>
    }
  </ix-layout-grid>
</div>
